import { orchestrateAuthentication } from './Authentication'
import { orchestrateConsole } from './Console'
import { orchestrateData } from './Data'
import { orchestrateNavigation } from './Navigation'

export function orchestrateMain() {
  orchestrateAuthentication()
  orchestrateNavigation()
  orchestrateConsole()
  orchestrateData()
}
